var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-class",class:[{'page-mass': _vm.theme == 'mass'}, {'page-prestige': _vm.theme == 'prestige'},{'page-nomenu': !_vm.isHaveMenu}]},[_c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }